import { useLocalStore } from 'mobx-react';
import { members as membersModel, simultaneousInterpretation } from '@/models';
export interface InterpreterOutputChannelChangeResp {
  interpreterYxMeetingUid: number;
  outputChannelLanguage: string;
}

export default function useInterpreterOutputChannelChange() {
  const { members, simultaneous } = useLocalStore(() => {
    return {
      simultaneous: simultaneousInterpretation,
      members: membersModel,
    };
  });

  const change = async (body: InterpreterOutputChannelChangeResp) => {
    const { interpreterYxMeetingUid, outputChannelLanguage } = body;
    members.updateInterpreterOutputChannelLanguage({
      interpreterYxMeetingUid,
      language: outputChannelLanguage,
    });
    simultaneous.setMainChannelVolumeComplement();
  };

  return change;
}
